import Flashcards from "@/modules/activities/flashcards/components/flashcards"
import type { Location } from "react-router-dom"
import { Navigate, useLocation, useParams } from "react-router-dom"

export interface FlashcardIdPageState {
  name: string
  course: string
  id: string
  userWeeklyObjectiveId: string
}

export default function FlashcardIdPage() {
  const location: Location<FlashcardIdPageState> = useLocation()
  const { id } = useParams<{ id: string }>()
  if (!id || !location.state) return <Navigate to="/activities/flashcards/notFound" replace />

  return (
    <div className="flex size-full">
      <Flashcards
        course={location.state.course}
        name={location.state.name}
        userWeeklyObjectiveId={location.state.userWeeklyObjectiveId}
        id={id}
        userActivityId={location.state.id}
      />
    </div>
  )
}
